import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20collage%20featuring%20multiple%20athletes%20in%20action%20across%20different%20sports%20like%20football%20basketball%20tennis%20and%20esports%2C%20dramatic%20stadium%20lighting%20with%20warm%20golden%20and%20red%20tones%2C%20epic%20cinematic%20composition%2C%20motion%20blur%20effects%2C%20professional%20sports%20photography%20style%2C%20dark%20background%20with%20vibrant%20color%20accents%2C%20energy%20and%20passion%20of%20competitive%20sports&width=1800&height=1200&seq=hero-bb-sports&orientation=landscape"
        alt="bb体育 - 专业体育平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full text-center px-4">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
            感受竞技魅力
          </h1>
          <p className="mt-4 md:mt-6 text-sm md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
            bb体育——您首选的专业体育平台，实时比分、赛事直播、深度资讯，一站式体育娱乐体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
            <Link
              to="/category/football"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              立即体验
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/15 text-white font-medium rounded-full hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer text-sm border border-white/25"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}